<template>
  <div>
    <div class="page-header d-flex" style="margin: 12px 12px 5px 12px;">
      <h4 class="page-title">
        <i class="fas fa-download"></i>
          Download
      </h4>
      <ul class="breadcrumbs ml-auto">
          <li class="nav-home mr-1">
              <a href="#">
                <i class="fas fa-home text-muted"></i>
              </a>
          </li>
          <li class="nav-item">
              <a class="font_15" href="#">Main</a>
          </li>
          <li class="separator">
              <i class="fa fa-angle-right"></i>
          </li>
          <li class="nav-item">
              <a class="font_15 font-weight-bold" href="#">Download</a>
          </li>
      </ul>
    </div>
    <b-card ondragstart="return false" onselectstart="return false">
      <b-tabs v-model="index">
        <b-tab title="WEBCastle Agent" :disabled="auth && auth.license && auth.license.WEBCastle.use == false">
          <h1 class="text-center">
            <b>WEBCastle Agent Downloads</b> : <span>Web Application Firewall</span>
          </h1>
          <hr>
          <div class="d-block text-center">
            <VclFacebook v-if="loading"/>
            <b-table :items="items" :fields="fields" bordered fixed class="fadeIn FadeOut" v-if="!loading">
              <template slot="img" slot-scope="row">
                <b-img center  v-bind="web_server_img" rounded :src="row.item.img"></b-img>
              </template>
              <template slot="os" slot-scope="row">
                <strong> {{row.item.os}} - {{ row.item.name }} </strong>
                <br>
                ( <b-button variant="link" @click="supported_modal = true" class="px-0">Supported Version</b-button> )
              </template>
              <template slot="version" slot-scope="row">
                {{row.item.version}}
              </template>
              <template slot="cmd" slot-scope="row">
                <b-button
                  block
                  size="m"
                  :variant="copy[row.item.key] == 'Copy' ? 'primary' : 'success'"
                  @click="agreement_check(row.item.key)"
                  class="mr-2"
                >
                {{ copy[row.item.key] ? copy[row.item.key] : 'Copy' }}
                </b-button>
                <b-button
                  block
                  size="m"
                  @click="row.toggleDetails"
                  variant="info"
                  class="mr-2"
                >{{ row.detailsShowing ? 'Hide' : 'Show' }} Script</b-button>
              </template>
              <template #row-details="row">
                <b-card>
                  <code>$ {{row.item.cmd }}</code><br><br>
                </b-card>
              </template>
            </b-table>
            <hr>
            <h5 class="text-left">
              <b-badge variant="warning">Notice</b-badge> : Web Firewall uses <span class="text-danger">port 10020</span> additionally
            </h5>
          </div>
        </b-tab>
        <b-tab title="WSFinder Agent" :disabled="auth && auth.license && auth.license.WSFinder.use == false">
          <h1 class="text-center">
            <b>WSFinder Agent Downloads</b> : <span>WebShell Finder</span>
          </h1>
          <hr>
          <div class="d-block text-center">
            <b-row>
              <b-col sm="3">
                <b-img left v-bind="web_server_img" rounded :src="'img/linux.png'"></b-img>
              </b-col>
              <b-col sm="9">
                <h6> <b> <span class="pr-1 pl-1" v-if="version.wsfinder"> v{{ version.wsfinder }}</span> Linux (<b-button variant="link" @click="supported_modal = true" class="px-0">Supported Version</b-button>)</b></h6>
                <p>shell Script should execute as root.</p>
                <code>$ {{wsf_linux}}</code><br><br>
                <b-button :disabled="lock" size="sm" type="button" :variant="copy.wsf_linux == 'Copy' ? 'primary' : 'success'" @click="agreement_check('wsf_linux')" block>{{copy.wsf_linux}}</b-button>
              </b-col>
            </b-row>
            <hr>
            <b-row>
              <b-col sm="3">
                <b-img left v-bind="web_server_img" rounded :src="'img/windows.png'"></b-img>
              </b-col>
              <b-col sm="9">
                <h6><b><span class="pr-1 pl-1" v-if="version.wsfinder"> v{{ version.wsfinder }}</span> Windows (<b-button variant="link" @click="supported_modal = true" class="px-0">Supported Version</b-button>)</b> </h6>
                <p>Run PowerShell as administrator and enter it.</p>
                <code>$ {{wsf_ps1}}</code><br><br>
                <b-button :disabled="lock" size="sm" type="button" :variant="copy.wsf_ps1 == 'Copy' ? 'primary' : 'success'" @click="agreement_check('wsf_ps1')" block>{{copy.wsf_ps1}}</b-button>
              </b-col>
            </b-row>
          </div>
        </b-tab>
        <!-- 개발 및 테스트 편의를 위해 만든 탭으로 스테이지 서버만 보여짐 -->
         <b-tab title="Agent Multiple Installation" v-if="use_token">
          <b-row>
            <b-col md="12">
              <b-form-group :label-cols="3" label="Select Install agent type">
                <b-form-checkbox-group id="down_type" v-model="down.multiple">
                  <b-form-checkbox value="wsfinder">WSFinder</b-form-checkbox>
                  <b-form-checkbox value="webcastle">WEBCastle</b-form-checkbox>
                </b-form-checkbox-group>
              </b-form-group>

              <b-form-group :label-cols="3" label="Select specify OS to be installed">
                <b-form-radio-group @change="change_os" id="os_type" v-model="down.os">
                  <b-form-radio value="win">Windows</b-form-radio>
                  <b-form-radio value="linux">Linux</b-form-radio>
                </b-form-radio-group>
              </b-form-group>

              <b-form-group v-if="down.multiple.indexOf('webcastle') > -1 && down.os != 'win'" :label-cols="3" label="Please select a web server">
                <b-form-radio-group id="web_type" v-model="down.webcastle">
                  <b-form-radio value="apache">Apache</b-form-radio>
                  <b-form-radio value="nginx">Nginx</b-form-radio>
                  <b-form-radio value="lsws">LiteSpeed</b-form-radio>
                </b-form-radio-group>
              </b-form-group>
              <b-form-group v-else-if="down.multiple.indexOf('webcastle') > -1" :label-cols="3" label="Please select a web server">
                <b-form-radio-group id="web_type" v-model="down.webcastle">
                  <b-form-radio value="iis">IIS</b-form-radio>
                </b-form-radio-group>
              </b-form-group>

              <hr>
              <b-button :disabled="lock" size="sm" type="button" variant="primary" block @click="ticket_token()"> Generate installation script & Copy</b-button>
              <hr v-if="down.is_copy">
              <p class="text-center" v-if="down.is_copy">* Downloadable time is 24 hours, which is a token used for bulk installation. Installation may be stopped due to license restrictions </p>
              <hr v-if="down.is_copy">
              <h3 class="text-center" v-if="down.is_copy">
                Excute under script on {{down.os == 'win' ? 'Powershell' : 'Shell'}} as {{down.os == 'win' ? 'Administrator' : 'root  '}}
              </h3>
              <hr>
              <pre class="p-1 mb-2 bg-dark">$ {{down.cmd}}</pre>
            </b-col>
          </b-row>
          <hr>
        </b-tab>
      </b-tabs>
    </b-card>
    <!-- 과금 안내 모달 -->
    <b-modal v-model="modal_charge_agree" title="Controls all agents" @ok="charge_agree" no-close-on-backdrop header-bg-variant="warning" class="text-center">
      <h6>1. The agent installation type is charged by the number of installations</h6>
      <br>
      <span class="text-danger font-weight-bold">2. Agent cannot be used unless it is an agent installable license</span>
      <br><br>
      <span class="text-danger font-weight-bold">3. When deleting an agent, You will not be charged until you delete it from the web</span>
      <hr>
      Please refer to the terms and conditions for details.
      <!-- <a target="_blank" :href="redir" class="card-link">
        <span class="text-dark">See More</span>
        <i class="fa fa-share"></i>
        {{redir}}
      </a> -->
      <hr>
      <h6> <b>Are you sure agree?</b></h6>
    </b-modal>
    <!-- 지원 범위 모달 -->
    <b-modal size="xl" v-model="supported_modal" title="Supported" ok-only header-bg-variant="success">
      <h5 class="text-center">Supported OS / Web Middle Ware / WHCP</h5>
      <table class="text-center table">
        <tr>
          <th class="h4">Agent Type</th>
          <th class="h4">OS</th>
          <th class="h4">Web Middle ware</th>
          <th class="h4">WHCP</th>
          <th class="h4">Comment</th>
        </tr>
        <tr>
          <td style="vertical-align:middle; border-right:solid 0.1px gray" rowspan="2">
            WEBCastle(Web Firewell)
          </td>
          <td style="vertical-align:middle; border-right:solid 0.1px gray">
            Windows Server <br><br>
            2008(64bit), 2008 R2(64bit), 2012(64bit), 2012 R2(64bit), <br>
            2016(64bit), 2019(64bit) <br>
            (ASP.NET, Redistribution package required)
          </td>
          <td style="vertical-align:middle; border-right:solid 0.1px gray">
            IIS <br><br>
            7.0, 7.5, 8.0, 8.5, 10.0
            <br>
          </td>
          <td style="vertical-align:middle; border-right:solid 0.1px gray" rowspan="2">
            Plesk
            <br>
            cPanel
          </td>
          <td style="vertical-align:middle; border-right:solid 0.1px gray">-</td>
        </tr>
        <tr>
          <td style="vertical-align:middle; border-right:solid 0.1px gray">
            Kernel
            <br>2.6.9 or higher<br><br>

            Ubuntu<br>14.04, 16.04, 18.04, 20.04 <br> <br>
            Centos<br>6.x, 7.x, 8.x
          </td>
          <td style="vertical-align:middle; border-right:solid 0.1px gray">
            Apache
            <br>2.2.x, 2.4.x <br><br>

            Nginx
            <br>1.9.11, 1.10.1, 1.11.x, 1.12.x, 1.13.x,<br>
            1.14.x, 1.15.x, 1.16.x, 1.17.x, 1.18.x, <br>
            1.19.x <br><br>

            OpenLightSpeed<br>
            1.3 or higher <br><br>
          </td>
          <td style="vertical-align:middle; border-right:solid 0.1px gray">-</td>
        </tr>
        <tr>
          <td style="vertical-align:middle; border-right:solid 0.1px gray" rowspan="2">
            WSFinder(Anti-Webshell)
          </td>
          <td style="vertical-align:middle; border-right:solid 0.1px gray">
            Windows Server <br><br>
            2008(64bit), 2008 R2(64bit), 2012(64bit), 2012 R2(64bit), <br>
            2016(64bit), 2019(64bit) <br>
          </td>
          <td style="vertical-align:middle; border-right:solid 0.1px gray" rowspan="2" colspan="2">
            Generally, no dependence
          </td>
          <td style="vertical-align:middle; border-right:solid 0.1px gray">-</td>
        </tr>
        <tr>
          <td style="vertical-align:middle; border-right:solid 0.1px gray">
            Linux(64bit)
            <br>
            <br>
            Kernel 2.6.23 or higher
          </td>
          <td style="vertical-align:middle; border-right:solid 0.1px gray">-</td>
        </tr>
      </table>
    </b-modal>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
